<template>
    <NuxtLayout name="main">
        <div class="header-container flex-center">
            <h1 class="font-variable font-bold">{{ $t("Toolbox") }}</h1>
        </div>
        <div class="navigation-container">
            <div class="container">
                <div v-for="(value, index) in options" class="navigation-item" :class="{ active: index == key }" @click="methods.navigate(index)">
                    {{ value.name }}
                </div>
            </div>
        </div>
        <div class="container">
            <section class="tools-container" v-for="tools in options">
                <h2 class="tools-name font-variable font-bold color-1">{{ tools.name }}</h2>
                <div class="tools">
                    <ProjectRoute v-for="value in tools.children" class="tool" :to="value.route">
                        <div v-if="value.tag" class="tool-tag">{{ value.tag }}</div>
                        <div class="tool-img">
                            <img :src="value.img" :alt="value.name" />
                        </div>

                        <div class="tool-info">
                            <div v-if="i18n.locale.value === 'zh'" class="label">{{ value.label }}</div>
                            <h3 class="name font-variable font-bold color-1">{{ value.name }}</h3>
                            <h4 class="descript ellipsis-4 font-normal">
                                {{ value.descript }}
                            </h4>
                        </div>
                    </ProjectRoute>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件属性
import { useComposable } from "./src/composable";

//* 获取I18n
const i18n = useI18n();

const { refs, options, methods } = useComposable();
const { key } = refs;

//* 组件挂载后获取数据并注册页面滚动事件
onMounted(() => {
    window.addEventListener("scroll", methods.handler);
});
//* 组件卸载后注销页面滚动事件
onUnmounted(() => window.removeEventListener("scroll", methods.handler));
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
